import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createCovidProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider => {
    return {
        key: "covid",
        label: "Covid",
        subLabel: "Resultados de encuestas de salud relacionadas con Covid-19",
        action: ctx.navigateModule("alumnos/covid"),
        search: (): ISearchResult[] => ([])
    };
};